import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {Group} from 'shared/models/target-groups/group';
import {GroupsRepository} from '../repositories/groups.repository';

@Injectable()
export class GroupsService {

  constructor(private groupsRepository: GroupsRepository) { }

  public getAllGroups(): Observable<Array<Group>> {
    return this.groupsRepository.getAllGroups();
  }

  public getGroup(id: String): Observable<Group> {
    return this.groupsRepository.getGroup(id);
  }

  public createGroup(newGroupName: String): Observable<Group> {
    const newGroup: Group = {
      name: newGroupName,
    };
    return this.groupsRepository.createGroup(newGroup);
  }

  public updateGroup(group: Group): Observable<Group> {
    return this.groupsRepository.updateGroup(group);
  }

  public deleteGroup(group: Group): Observable<boolean> {
    return this.groupsRepository.deleteGroup(group);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/groups/services/groups.service.ts